import { operatorService } from '../../_services'
import { router } from '@/_helpers/index'
import { localStore } from '@/_utils/localstore'

const currentUser = JSON.parse(localStore.getItem('user') as string)

const initialState = currentUser
  ? { status: { loggedIn: true }, currentUser, messages: {}, units: [] }
  : { status: {}, user: null, messages: {}, units: [] }

export const authentication = {
  namespaced: true,
  state: initialState,
  actions: {
    async login({ dispatch, commit }: any, { username, password }: any) {
      commit('LOGIN_REQUEST', { username })

      return await operatorService
        .login(username, password)
        .then(user => {
          return dispatch('settings/get', {}, { root: true }).then(() => {
            commit('LOGIN_SUCCESS', user)
            router.push('/dashboard').catch(error => false)
          })
        })
        .catch(errorMsg => {
          commit('LOGIN_FAILURE', errorMsg)
        })
    },
    logout({ commit }: any) {
      router.push('/login').catch(error => false)
      operatorService.logout()
      commit('LOGOUT')
    }
  },
  mutations: {
    LOGIN_REQUEST(state: any, user: any) {
      state.status = { loggingIn: true }
      state.operator = user
    },
    LOGIN_SUCCESS(state: any, response: any) {
      state.status = { loggedIn: true }
      state.operator = response.data
      state.currentUser = state.operator
    },
    LOGIN_FAILURE(state: any, errorMsg: any) {
      state.status = { loggingIn: false }
      state.messages = { error: [errorMsg] }
      state.operator = null
    },
    RESET_STATE(state: any) {
      const init = JSON.parse(JSON.stringify({ status: {}, user: null, currentUser: null, messages: {} }))
      Object.keys(init).forEach(key => {
        state[key] = init[key]
      })
    },
    LOGOUT(state: any) {
      state.status = {}
      state.operator = null
    }
  },
}
